import { FaroCoreApiTypes } from "@stellar/core-api-client";

/**
 * Gets the disabled roles based on the selected role.
 * For example an enterprise executive can't be downgraded to a project manager.
 *
 * @param selectedRole The current selected role to check
 * @returns Array filled with the roles that should be disabled
 * @see https://faro01.atlassian.net/wiki/spaces/HBWEBDEV/pages/4473782411/Workspace+Role+Hierarchy
 */
export function getDisabledRoles(
  selectedRole: FaroCoreApiTypes.CompanyRole
): FaroCoreApiTypes.CompanyRole[] {
  switch (selectedRole) {
    case "COMPANY_EXECUTIVE":
      return [
        "COMPANY_EXECUTIVE",
        "COMPANY_MANAGER",
        "GROUP_VIEWER",
        "PROJECT_MANAGER",
      ];
    case "COMPANY_VIEWER":
      return [
        "COMPANY_VIEWER",
        "COMPANY_MANAGER",
        "GROUP_VIEWER",
        "PROJECT_MANAGER",
      ];
    case "COMPANY_MANAGER":
      return ["COMPANY_MANAGER", "GROUP_VIEWER", "PROJECT_MANAGER", "MEMBER"];
    case "GROUP_VIEWER":
      return ["GROUP_VIEWER", "COMPANY_MANAGER", "PROJECT_MANAGER", "MEMBER"];
    case "PROJECT_MANAGER":
      return ["COMPANY_MANAGER", "GROUP_VIEWER", "PROJECT_MANAGER", "MEMBER"];
    case "MEMBER":
      return ["COMPANY_MANAGER", "GROUP_VIEWER", "PROJECT_MANAGER", "MEMBER"];
    default:
      return [];
  }
}
